import { render } from "./ProductCatalog.vue?vue&type=template&id=f17279b6&ts=true&lang=pug"
import script from "./ProductCatalog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCatalog.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__